module.exports={
  "name": "copa-passes",
  "version": "1.0.0",
  "description": "",
  "main": "",
  "scripts": {
    "start": "gulp",
    "build": "NODE_ENV=PROD gulp build",
    "build:qa": "NODE_ENV=QLT gulp build",
    "eslint": "eslint app/assets/js --no-cache"
  },
  "author": "O Globo",
  "license": "ISC",
  "devDependencies": {
    "babel-cli": "^6.26.0",
    "babel-core": "^6.26.0",
    "babel-preset-env": "^1.6.0",
    "babel-register": "^6.26.0",
    "babelify": "^7.3.0",
    "browser-sync": "^2.9.11",
    "browserify": "^14.4.0",
    "del": "^3.0.0",
    "eslint": "^4.18.1",
    "eslint-config-airbnb-base": "^12.1.0",
    "eslint-plugin-import": "^2.9.0",
    "gulp": "^3.9.1",
    "gulp-cache": "^1.0.1",
    "gulp-concat": "^2.6.1",
    "gulp-cssnano": "^2.1.2",
    "gulp-imagemin": "^2.2.1",
    "gulp-load-plugins": "^1.5.0",
    "gulp-plumber": "^1.1.0",
    "gulp-pug": "^3.3.0",
    "gulp-sass": "^3.1.0",
    "gulp-sass-variables": "^1.1.1",
    "gulp-sourcemaps": "^2.6.0",
    "gulp-uglify": "^1.3.0",
    "gulp-watch": "^4.3.3",
    "pug": "^2.0.0-beta11",
    "pug-lint": "^2.5.0",
    "run-sequence": "^2.0.0",
    "sass-lint": "^1.12.1",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.1.0"
  },
  "dependencies": {
    "babel-polyfill": "^6.26.0"
  }
}
